import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import ListPageHeader from '@/components/ListPageHeader';
import { ProductLogoMediumWorkSchedulesAndShifts } from '@/components/Logo';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/work-schedule/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.workSchedule'
  });
  useDocumentTitle(t('pageTitle'));
  const matchRoute = useMatchRoute();
  /** 店舗詳細は `StoreShiftDetailHeader` があるためモジュールの ListPageHeader は出さない */
  const isStoreDetail = matchRoute({
    to: '/work-schedule/shifts/$storeId',
    fuzzy: true
  });
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <div className="flex h-full min-h-0 min-w-0 flex-col">
      {!isStoreDetail ? <ListPageHeader icon={<ProductLogoMediumWorkSchedulesAndShifts />} title={t('pageTitle')} tabs={[{
      to: '/work-schedule/overview',
      children: t('tabs.overview'),
      activeOptions: {
        exact: true
      }
    }, {
      to: '/work-schedule/shifts',
      children: t('tabs.workSchedule'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/work-schedule/alerts',
      children: t('tabs.alerts'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/work-schedule/rule-and-policy',
      children: t('tabs.ruleAndPolicy'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/work-schedule/operation-activity',
      children: t('tabs.operationActivity'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/work-schedule/settings',
      children: t('tabs.settings'),
      activeOptions: {
        exact: false
      }
    }]} /> : null}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Outlet />
      </div>
    </div>;
}